import { ENTERTAINMENT_LIST, ENTERTAINMENT_CHANGE_STATUS, ENTERTAINMENT_ADDEDIT, ENTERTAINMENT_DELETE, ENTERTAINMENT_GETONE, ENTERTAINMENT_IMAGE_UPLOAD } from "../../api/constApi";
import { fileAuthHeader, authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const entertainmentListApi = (payload) => {
    return apiInstance.post(ENTERTAINMENT_LIST, payload, {
        headers: fileAuthHeader(),
    });
};

export const entertainmentChangeStatusApi = (payload) => {
    return apiInstance.post(ENTERTAINMENT_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditEntertainmentApi = (payload) => {
    return apiInstance.post(ENTERTAINMENT_ADDEDIT, payload, {
        headers: authHeader(),
    });
};
export const DeleteEntertainmentApi = (payload) => {
    return apiInstance.post(ENTERTAINMENT_DELETE, payload, {
        headers: authHeader(),
    });
};

export const getOneEntertainmentApi = (payload) => {
    return apiInstance.post(ENTERTAINMENT_GETONE, payload, {
        headers: authHeader(),
    });
};

export const entertainmentImageUploadApi = (payload) => {
    return apiInstance.post(ENTERTAINMENT_IMAGE_UPLOAD, payload, {
        headers: fileAuthHeader(),
    });
};